module.exports = __webpack_public_path__ + "sgbycz2/img/ico.png?6afc84ee";